<template>
    <div class="app-container">
        <el-skeleton v-if="pageLoading" :rows="12" animated />
        <div v-else class="upload-box">
            <h4>上传图片/动图</h4>
            <upload-one v-model="form.picture" width="350px" height="550px"></upload-one>
            <p class="tip">*请上传png/jpg/jpeg图片，或gif动图</p>
            <el-button class="save-btn" type="primary" :loading="submitting" @click="setLaunchPicture">保存</el-button>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request"

export default {
    data: () => ({
        form: {
            picture: null
        },
        pageLoading: true,
        submitting: false
    }),
    methods: {
        getLaunchPicture() {
            request({
                url: "/api/backend/settings",
                method: "get",
                params: {
                    system_logs_content: '基础管理-运营管理-启动页查看',
                    prefix: "start_page"
                }
            }).then(({ data: { data } }) => {
                this.form.picture = data[0].value
                this.pageLoading = false
            })
        },
        async setLaunchPicture() {
            this.submitting = true
            await request({
                url: "/api/backend/settings/store",
                method: "post",
                data: {
                    "start_page": {
                        value: this.form.picture
                    }
                }
            })
            this.$message({
                message: "已保存!",
                type: 'success'
            });
            this.submitting = false
        }
    },
    created() {
        this.getLaunchPicture()
    }
}
</script>

<style lang="scss" scoped>
.upload-box {
    // margin-left: 100px;
    // text-align: center;

    h4 {
        margin-top: 0;
    }

    .tip {
        font-size: .9rem;
        color: #909399;
    }
}
</style>